<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Filter people</ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="clearFilters()">
          <fa-icon [icon]="['far', 'trash-alt']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
          <span>Clear</span>
        </ion-button>
        <ion-button (click)="filter()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            @if (email_lists && email_lists.length != 0) {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="email_list_select_options" labelPlacement="stacked" fill="outline" (ionCancel)="clearEmailList()" [(ngModel)]="filter_params['email_list_id']">
                    <div slot="label">Email List<ion-text class="optional">optional</ion-text></div>
                    @for (email_list of email_lists; track email_list) {
                      <ion-select-option value="{{email_list.id}}">{{email_list.title}}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            @if (tags && tags.length != 0) {
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="tag_select_options" labelPlacement="stacked" fill="outline" (ionCancel)="clearTag()" [(ngModel)]="filter_params['tag_id']">
                    <div slot="label">Tag<ion-text class="optional">optional</ion-text></div>
                    @for (tag of tags; track tag) {
                      <ion-select-option value="{{tag.id}}">
                        @if (!tag.group) {
                          <span>Ungrouped > </span>
                        }
                        @if (tag.group) {
                          <span>{{tag.group.title}} > </span>
                          }{{tag.title}}
                        </ion-select-option>
                      }
                    </ion-select>
                  </ion-col>
                </ion-row>
              }
              @if (!hide_organisation_selector) {
                <ion-row>
                  <ion-col>
                    @if (organisation_title) {
                      <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{organisation_title}} (click)="presentOrganisationPickerModal()">
                        <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                      </ion-input>
                    }
                    @if (!organisation_title) {
                      <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentOrganisationPickerModal()">
                        <div slot="label">Organisation<ion-text class="optional">optional</ion-text></div>
                      </ion-input>
                    }
                  </ion-col>
                </ion-row>
              }
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearHasCreditLimit()" interface="alert" [interfaceOptions]="has_credit_limit_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['has_credit_limit']">
                    <div slot="label">Has credit limit<ion-text class="optional">optional</ion-text></div>
                    <ion-select-option [value]="true">Yes</ion-select-option>
                    <ion-select-option [value]="false">No</ion-select-option>
                  </ion-select>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearHasAmountOwing()" interface="alert" [interfaceOptions]="has_amount_owing_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['has_amount_owing']">
                    <div slot="label">Has amount owing<ion-text class="optional">optional</ion-text></div>
                    <ion-select-option [value]="true">Yes</ion-select-option>
                    <ion-select-option [value]="false">No</ion-select-option>
                  </ion-select>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearHasExceededCreditLimit()" interface="alert" [interfaceOptions]="has_exceeded_credit_limit_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['has_exceeded_credit_limit']">
                    <div slot="label">Has exceeded credit limit<ion-text class="optional">optional</ion-text></div>
                    <ion-select-option [value]="true">Yes</ion-select-option>
                    <ion-select-option [value]="false">No</ion-select-option>
                  </ion-select>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="archived_options" (ionCancel)="clearArchived()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['archived']">
                    <div slot="label">Archived<ion-text class="optional">optional</ion-text></div>
                    <ion-select-option [value]="false">No</ion-select-option>
                    <ion-select-option [value]="true">Yes</ion-select-option>
                  </ion-select>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ion-row>
      </ion-grid>
    }

  </ion-content>